import { makeStyles, FormControlLabel, Radio } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  radio: {
    color: '#e4e7eb',
  },
  label: {
    // width: '10.5rem',
    '& .MuiTypography-body1': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: '500',
    },
    '& .Mui-disabled': {
      color: '#e4e7eb',
    },
  },
}));

const CustomRadio = (props) => {
  const { name = '', label = '', color = 'primary', ...rest } = props;
  const classes = useStyles();
  return (
    <FormControlLabel
      control={<Radio {...rest} color={color} className={classes.radio} />}
      name={name}
      label={label}
      className={classes.label}
    />
  );
};

export default CustomRadio;
